import React from 'react';
import { Box } from '@mui/material';
import { withStyles } from '@mui/styles';

import { imageMappings } from './imageMappings';
import { MultiSelect } from '../../components/Selects';
import ConnectorQuickView from './ConnectorQuickView';
import { PubSub } from '../../utils/eventUtils';

const ConnectorQuickViewContainer = ({
  classes,
  dataArr,
  initConnectorId,
  theme,
  ...props
}: any) => {
  const data = dataArr[0];
  const { id, connectorType, connectorName } = data;

  const getDataByConnectorId = (cId: any) => {
    for (const item of dataArr) {
      if (item.id === cId) {
        return item;
      }
    }
  };

  const dropdownMicrosoftOptions = dataArr.map((item: any) => ({
    label: item.metadata.azureTenantDisplayName,
    value: item.id,
  }));

  const dropdownGCPOptions = dataArr.map((item: any) => ({
    label: item.metadata.organizationId,
    value: item.id,
  }));

  const dropdownAWSOptions = dataArr.map((item: any) => ({
    label: item.accountId,
    value: item.connectorId,
  }));

  const shareData = {
    MICROSOFT: {
      dropdownOptions: dropdownMicrosoftOptions,
      myOption: {
        label: data.metadata.azureTenantDisplayName,
        value: id,
      },
    },
    GOOGLE: {
      dropdownOptions: dropdownGCPOptions,
      myOption: {
        label: data.organizationId,
        value: id,
      },
    },
    AWS: {
      dropdownOptions: dropdownAWSOptions,
      myOption: {
        label: data.accountId,
        value: id,
      },
    },
  };

  const renderImage = () => {
    const image = imageMappings[connectorType][theme.palette.mode];
    return (
      <img
        src={image}
        alt=""
        className={`${
          connectorType === 'SECURITYSTUDIO'
            ? classes.ssIconStyle
            : classes.iconStyle
        }`}
      />
    );
  };

  const handleClick = () => {
    const type = connectorType.toLowerCase();
    props.history.push(`/customer/connector/connector-details/${type}`);
  };

  const selectHandler = (name: any, value: any) => {
    PubSub.publish(
      'ConnectorQuickViewContainer:render',
      getDataByConnectorId(value.value)
    );
  };

  return (
    <section className={classes.mainContainer}>
      <section className={classes.titleSection}>
        <h3 className={classes.title}>{connectorName}</h3>
      </section>
      {renderImage()}
      <Box className={classes.detailsButton} onClick={handleClick}>
        DETAILS
      </Box>
      {connectorType !== 'SECURITYSTUDIO' && (
        <section className={classes.dropdown}>
          <MultiSelect
            name="days"
            isMulti={false}
            options={shareData[connectorType].dropdownOptions}
            onChange={selectHandler}
            values={shareData[connectorType].myOption}
            required
            classes={{
              select: classes.button,
            }}
          />
        </section>
      )}
      <ConnectorQuickView data={data} {...props} />
    </section>
  );
};

const styles = ({ palette }: any) => {
  return {
    titleSection: {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
    },
    dropdown: {
      marginBottom: 35,
    },
    button: {
      padding: '5px !important',
      border: `1px solid ${palette.primary.oldBorder2}`,
    },
    detailsButton: {
      width: '7.5rem',
      height: '1.667rem',
      borderRadius: 5,
      border: `1px solid ${palette.primary.green}`,
      margin: '0 auto 15px auto',
      color: palette.primary.main,
      fontSize: '1.083rem',
      lineHeight: 1.33,
      paddingTop: 1,
      cursor: 'pointer',
      textTransform: 'uppercase',
    },
    mainContainer: {
      width: '34.583rem',
      height: '100%',
      padding: '11px 26px',
      textAlign: 'center',
      backgroundColor: palette.background.connectorQuickView,
    },
    title: {
      fontSize: '1.167rem',
      lineHeight: 1.5,
      fontWeight: 'bold',
      color: palette.text.text14,
      paddingBottom: 2,
      borderBottom: `1px solid ${palette.primary.modalBorder}`,
      margin: '0px 0 20px 0 !important',
    },
    iconStyle: {
      width: '10rem',
      height: '5rem',
      textAlign: 'center',
      marginBottom: 20,
    },
    ssIconStyle: {
      width: '10rem',
      height: '4rem',
      margin: '0.5rem 0',
      textAlign: 'center',
    },
  };
};

// @ts-expect-error TS(2345): Argument of type '({ palette }: any) => { titleSec... Remove this comment to see the full error message
export default withStyles(styles, { withTheme: true })(
  ConnectorQuickViewContainer
);
